// extracted by mini-css-extract-plugin
module.exports = {"container":"overflowPopover_container__1dHgp","overlayTop":"overflowPopover_overlayTop__XscAb","overlayRight":"overflowPopover_overlayRight__2hyjh"};